export { default as Tooltip } from './Tooltip';
export type { TooltipProps } from './Tooltip';
